import PhoneInput from '../inputs/PhoneInput';
import createField from './createField';

const PhoneField = createField(PhoneInput);

export default PhoneField;